import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

class VehicleService {
    constructor() {
        this.vehicleService = axios.create({
            baseURL:
                Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.VEHICLE.BASE_PATH,
        });
    }

    base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.VEHICLE.BASE_PATH;

    getVehicleList = async (token, filters) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(filters),
        };
        return await axios
            .post(this.base_url + Globals.BFF_PATH.VEHICLE.GET, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getRentingVOSimulatorCall = async (url, bodyCall, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(bodyCall),
        };
        return await axios
            .post(url, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getRentingVOSimulationFinder = async (url, bodyCall, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(bodyCall),
        };
        return await axios
            .post(url, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getAgrupations = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.AUCTIONS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getFilters = async (token, filter) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(filter),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.FILTERS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getFiltersAdjudication = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.FILTERS_ADJUDICATION,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getFiltersDealerReceptor = async (token, filter) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(filter),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.FILTERS_RECEIVING_DEALERS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getModels = async (token, brands) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(brands),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_MODELS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getFavoritesCount = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_FAVOURITE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    setFavourite = async (token, vehicleId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(vehicleId),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.POST_FAVOURITE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    deleteFavourite = async (token, vehicleId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(vehicleId),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.REMOVE_FAVOURITE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    insertBid = async (aws_url, apikeyname, apikeyvalue, bid, token) => {
        var headers = {
            Authorization: `Bearer ${token}`,
        };
        headers[apikeyname] = apikeyvalue;
        var config = {
            headers: headers,
        };
        const data = bid;
        return await axios
            .post(aws_url, JSON.stringify(data), config)
            .then(response => {
                if (response && response.data) {
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
                return null;
            });
    };

    getBids = async (aws_url, apikeyname, apikeyvalue, vehicleId, token) => {
        var headers = {
            Authorization: `Bearer ${token}`,
        };
        headers[apikeyname] = apikeyvalue;
        const config = {
            headers: headers,
        };
        const data = [vehicleId];
        return await axios
            .post(aws_url, data, config)
            .then(response => {
                if (response && response.data && response.data.length > 0) {
                    return response.data[0];
                } else {
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getBidsCount = async (aws_url, apikeyname, apikeyvalue, bid, token) => {
        var headers = {
            Authorization: `Bearer ${token}`,
        };
        headers[apikeyname] = apikeyvalue;
        var config = {
            headers: headers,
        };
        return await axios
            .post(aws_url, bid, config)
            .then(response => {
                if (response && response.data && response.data.length > 0) {
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    bid,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehicleBids = (aws_url, apikeyname, apikeyvalue, data, token) => {
        const config = {
            headers: {
                [apikeyname]: apikeyvalue,
                Authorization: `Bearer ${token}`,
            },
        };
        return axios
            .post(aws_url, data, config)
            .then(response => {
                if (response?.data) {
                    return response.data;
                }
            })
            .catch(error => {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getBidActive = async (
        aws_url,
        apikeyname,
        apikeyvalue,
        vehicleId,
        token
    ) => {
        var headers = {
            Authorization: `Bearer ${token}`,
        };
        headers[apikeyname] = apikeyvalue;
        var config = {
            headers: headers,
        };
        const data = vehicleId;
        return await axios
            .post(aws_url, data, config)
            .then(response => {
                if (response && response.data && response.data.length > 0) {
                    return response.data[0];
                } else {
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehiclesAdjudication = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_VEHICLES_ADJUDICATION,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehiclesSoldVWR = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_VEHICLES_SoldVWR,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehiclesDealerReceptor = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_RECEPTOR_DEALERS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    GetNotBuyTypes = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_NOT_BUY_TYPE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getMonthFilterVehiclesAdjudication = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.FILTERS_ADJUDICATION_MONTH,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getListStatesVehiclesAdjudication = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_STATES_ADJUDICATION,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getNumberAdjudication = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_ADJUDICATION_COUNT,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getNumberDealerReceptor = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_RECEPTOR_DEALERS_COUNT,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };
    getVehiclesAdjudicationExcel = async (token, value) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(value),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_EXCEL_ADJUDICATED,
                data,
                config
            )
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehicleStatus = async (token, vehicleId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(vehicleId),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_STATUS,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getVehicleInformation = async (token, vehicleId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(vehicleId),
        };
        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.VEHICLE.GET_INFORMATION,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    getCurrentExportOffer = async (object, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(object),
        };
        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.VEHICLE.GET_CURRENT_EXPORTER_OFFER,
                data,
                config
            )
            .then(response => {
                if (response?.data?.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
}

export default VehicleService;
